import { Alert, IconButton, Slide, Snackbar } from '@mui/material';
import { useErrorStore } from '@oai-frontend-monorepo/state-management';
import CloseIcon from '@mui/icons-material/Close';
import { memo, useCallback, useMemo } from 'react';

const ErrorSnackContainer = () => {
  const store = useErrorStore();

  const errorMessage = store.errorMessage;
  const isOpen = !!errorMessage;

  const handleClose = useCallback(() => {
    store.setErrorMessage('');
  }, [store]);

  const action = useMemo(() => {
    return (
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    );
  }, [handleClose]);

  return (
    <Snackbar
      open={isOpen}
      autoHideDuration={15000}
      action={action}
      TransitionComponent={Slide}
      onClose={handleClose}
    >
      <Alert
        style={{ backgroundColor: 'red' }}
        onClose={handleClose}
        severity="error"
        variant="filled"
      >
        {errorMessage}
      </Alert>
    </Snackbar>
  );
};

export default memo(ErrorSnackContainer);
